import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'gatsby-plugin-intl';
import styled from 'styled-components';

import SubTitle from './styledComponents/SubTitle';
import H3 from './styledComponents/H3';
import H4 from './styledComponents/H4';
import Paragraph from './styledComponents/Paragraph';
import RuleDescription from './styledComponents/RuleDescription';
import ChapterSpace from './styledComponents/ChapterSpace';

import { AnchorBlock,Container,Cell,Grid,ParentAnchor,ChapterHeader } from './blockComponents';
import { PlainImage } from './imageComponents';
import { ImageMultilang, ImageMultilangResp } from './utility/imageMultilang';

const HierarchyImg = styled.div`
    max-width: 496px;
    width: 100%;
`;
const HierarchyItem2Img = styled.div`
    max-width: 736px;
    width: 100%;
`;
const SlidersImg = styled.div`
    max-width: 432px;
    width: 100%;
`;
const Badge = styled.span`
    display: inline-block;
    margin-left: 8px;
    padding: 8px 20px;

    font-size: 15px;
    font-weight: 500;
    line-height: 1;

    color: #000;

    background: var(--green1);
    border-radius: 4px;
`;

function Design({ 
    intl,
    activeAnchor,
    setActiveAnchor,
    pageHeight,
    refs
    }) {
        
    return (
        <ParentAnchor
            key='designSection'
            blockId="design-section"
            blockName='designSection'
            refs={refs}>
            <ChapterHeader title={intl.formatMessage({ id: 'design_title' })}></ChapterHeader>
            <Container>
                <Grid>
                    <Cell col={12} colXl={10} colXxl={8} leftXl={2} leftXxl={3}>
                        <SubTitle space="Top">{intl.formatMessage({ id: 'design_subtitle' })}</SubTitle>
                        <AnchorBlock 
                            key='designHierarchy'
                            blockName='designHierarchy'
                            blockId='design-hierarchy'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'design_1_1' })}</H3>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'design_1_2' })}</Paragraph>
                            <Paragraph>{intl.formatMessage({ id: 'design_1_3' })}</Paragraph>

                            <H4 space="TopDown">1. {intl.formatMessage({ id: 'design_1_4' })}</H4>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'design_1_5' })}</Paragraph>
                            <HierarchyImg>
                                <ImageMultilang 
                                    intl={intl} 
                                    last="xs"
                                    imageRu='hierarchy/attention-1-ru@2x.jpg'
                                    imageUk='hierarchy/attention-1-uk@2x.jpg'
                                    imageEn='hierarchy/attention-1-en@2x.jpg'/>
                            </HierarchyImg>

                            <H4 space="TopDown">2. {intl.formatMessage({ id: 'design_1_6' })}</H4>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'design_1_7' })}</Paragraph>
                            <HierarchyImg>
                                <ImageMultilang 
                                    intl={intl} 
                                    last=""
                                    imageRu='hierarchy/attention-2-ru@2x.jpg'
                                    imageUk='hierarchy/attention-2-uk@2x.jpg'
                                    imageEn='hierarchy/attention-2-en@2x.jpg'/>
                            </HierarchyImg>
                            <Paragraph space="TopDown">{intl.formatMessage({ id: 'design_1_8' })}</Paragraph>
                            <HierarchyImg>
                                <ImageMultilang 
                                    intl={intl} 
                                    last="xs"
                                    imageRu='hierarchy/attention-3-ru@2x.jpg'
                                    imageUk='hierarchy/attention-3-uk@2x.jpg'
                                    imageEn='hierarchy/attention-3-en@2x.jpg'/>
                            </HierarchyImg>

                            <H4 space="TopDown">3. {intl.formatMessage({ id: 'design_1_9' })}</H4>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'design_1_10' })}</Paragraph>
                            <HierarchyImg>
                                <ImageMultilang 
                                    intl={intl} 
                                    last="xs"
                                    imageRu='hierarchy/attention-4-ru@2x.jpg'
                                    imageUk='hierarchy/attention-4-uk@2x.jpg'
                                    imageEn='hierarchy/attention-4-en@2x.jpg'/>
                            </HierarchyImg>
                            <Paragraph space="TopDown">{intl.formatMessage({ id: 'design_1_11' })}</Paragraph>
                            <SlidersImg>
                                <ImageMultilang 
                                    intl={intl} 
                                    last=""
                                    imageRu='hierarchy/sliders-ru@2x.jpg'
                                    imageUk='hierarchy/sliders-uk@2x.jpg'
                                    imageEn='hierarchy/sliders-en@2x.jpg'/>
                            </SlidersImg>
                            <Paragraph space="Top">{intl.formatMessage({ id: 'design_1_12' })}</Paragraph>
                        </AnchorBlock>
                        <AnchorBlock 
                            key='designMessage'
                            blockName='designMessage'
                            blockId='design-message'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'design_2_1' })}</H3>
                            <SubTitle space="Down">{intl.formatMessage({ id: 'design_2_2' })}</SubTitle>
                            <Paragraph><FormattedHTMLMessage id="design_2_3" /></Paragraph>

                            <div id="keyvisual-block">
                                <H4 space="TopDown">{intl.formatMessage({ id: 'design_2_4' })}</H4>
                                <Paragraph space="Down">{intl.formatMessage({ id: 'design_2_5' })}</Paragraph>
                                <HierarchyImg>
                                    <PlainImage src="hierarchy/new/billboard-1@2x.jpg" alt="" />
                                    <ImageMultilang 
                                        intl={intl} 
                                        last=""
                                        imageRu='hierarchy/billboard-1@2x.jpg'
                                        imageUk='hierarchy/billboard-1@2x.jpg'
                                        imageEn='hierarchy/billboard-1@2x.jpg'/>
                                </HierarchyImg>
                                <Paragraph space="Top">{intl.formatMessage({ id: 'design_2_6' })}</Paragraph>
                            </div>
                            
                            <div id="value-block">
                                <H4 space="TopDown">{intl.formatMessage({ id: 'design_2_7' })}</H4>
                                <Paragraph space="Down">{intl.formatMessage({ id: 'design_2_8' })}</Paragraph>
                                <Paragraph>{intl.formatMessage({ id: 'design_2_9' })}</Paragraph>
                                <Paragraph space="Down">{intl.formatMessage({ id: 'design_2_11' })}</Paragraph>
                                <Paragraph space="Down">{intl.formatMessage({ id: 'design_2_13' })}</Paragraph>
                                <ImageMultilangResp
                                    intl={intl} 
                                    last="xs"
                                    imageRu='hierarchy/billboard-2-ru.png'
                                    imageUk='hierarchy/billboard-2-uk.png'
                                    imageEn='hierarchy/billboard-2-en.png'
                                    imageRuMob='hierarchy/billboard-2-mob-ru@2x.png'
                                    imageUkMob='hierarchy/billboard-2-mob-uk@2x.png'
                                    imageEnMob='hierarchy/billboard-2-mob-en@2x.png' />
                            </div>

                            <div id="co-branding-block">
                                <H4 space="TopDown">{intl.formatMessage({ id: 'design_2_14' })}</H4>
                                <Paragraph space="Down">{intl.formatMessage({ id: 'design_2_15' })}</Paragraph>
                                <ImageMultilangResp
                                    intl={intl} 
                                    last="xs"
                                    imageRu='hierarchy/billboard-3-ru.png'
                                    imageUk='hierarchy/billboard-3-uk.png'
                                    imageEn='hierarchy/billboard-3-en.png'
                                    imageRuMob='hierarchy/billboard-3-mob-ru@2x.png'
                                    imageUkMob='hierarchy/billboard-3-mob-uk@2x.png'
                                    imageEnMob='hierarchy/billboard-3-mob-en@2x.png' />
                            </div>

                            <div id="call-to-action-block">
                                <H4 space="TopDown">{intl.formatMessage({ id: 'design_2_16' })}</H4>
                                <Paragraph space="Down"><FormattedHTMLMessage id="design_2_17" /></Paragraph>
                                <ImageMultilangResp
                                    intl={intl} 
                                    last="xs"
                                    imageRu='hierarchy/billboard-4-ru.png'
                                    imageUk='hierarchy/billboard-4-uk.png'
                                    imageEn='hierarchy/billboard-4-en.png'
                                    imageRuMob='hierarchy/billboard-4-mob-ru@2x.png'
                                    imageUkMob='hierarchy/billboard-4-mob-uk@2x.png'
                                    imageEnMob='hierarchy/billboard-4-mob-en@2x.png' />
                            </div>

                            <div id="reason-block">
                                <H4 space="TopDown">{intl.formatMessage({ id: 'design_2_18' })}</H4>
                                <Paragraph space="Down"><FormattedHTMLMessage id="design_2_19" /><br />{intl.formatMessage({ id: 'design_2_20' })}</Paragraph>
                                <Paragraph space="Down"><FormattedHTMLMessage id="design_2_21" /><br/>{intl.formatMessage({ id: 'design_2_22' })}</Paragraph>
                                <ImageMultilangResp
                                    intl={intl} 
                                    last="xs"
                                    imageRu='hierarchy/billboard-5-ru.png'
                                    imageUk='hierarchy/billboard-5-uk.png'
                                    imageEn='hierarchy/billboard-5-en.png'
                                    imageRuMob='hierarchy/billboard-5-mob-ru@2x.png'
                                    imageUkMob='hierarchy/billboard-5-mob-uk@2x.png'
                                    imageEnMob='hierarchy/billboard-5-mob-en@2x.png' />
                            </div>

                            <div id="more-block">
                                <H4 space="TopDown">{intl.formatMessage({ id: 'design_2_23' })}</H4>
                                <Paragraph space="Down">{intl.formatMessage({ id: 'design_2_24' })}</Paragraph>
                                <ImageMultilangResp
                                    intl={intl} 
                                    last="xs"
                                    imageRu='hierarchy/billboard-6-ru.png'
                                    imageUk='hierarchy/billboard-6-uk.png'
                                    imageEn='hierarchy/billboard-6-en.png'
                                    imageRuMob='hierarchy/billboard-6-mob-ru@2x.png'
                                    imageUkMob='hierarchy/billboard-6-mob-uk@2x.png'
                                    imageEnMob='hierarchy/billboard-6-mob-en@2x.png' />
                                <Paragraph space="TopDown">{intl.formatMessage({ id: 'design_2_25' })}</Paragraph>
                                <ImageMultilangResp
                                    intl={intl} 
                                    last="xs"
                                    imageRu='hierarchy/billboard-7-ru.png'
                                    imageUk='hierarchy/billboard-7-uk.png'
                                    imageEn='hierarchy/billboard-7-en.png'
                                    imageRuMob='hierarchy/billboard-7-mob-ru@2x.png'
                                    imageUkMob='hierarchy/billboard-7-mob-uk@2x.png'
                                    imageEnMob='hierarchy/billboard-7-mob-en@2x.png' />
                                <Paragraph space="Top">{intl.formatMessage({ id: 'design_2_26' })}</Paragraph>
                            </div>
                        </AnchorBlock>
                        <AnchorBlock 
                            key='designConsider'
                            blockName='designConsider'
                            blockId='design-consider'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'design_3_1' })}</H3>
                            <H4 space="Down">{intl.formatMessage({ id: 'design_3_2' })}</H4>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'design_3_3' })}</Paragraph>
                            <Grid>
                                <Cell col={6}>
                                    <RuleDescription />
                                    <ImageMultilang 
                                        intl={intl} 
                                        last="xs"
                                        imageRu='hierarchy/content-1-ru@2x.jpg'
                                        imageUk='hierarchy/content-1-uk@2x.jpg'
                                        imageEn='hierarchy/content-1-en@2x.jpg'/>
                                </Cell>
                                <Cell col={6}>
                                    <RuleDescription rule="do" />
                                    <ImageMultilang 
                                        intl={intl} 
                                        last="xs"
                                        imageRu='hierarchy/content-2-ru@2x.jpg'
                                        imageUk='hierarchy/content-2-uk@2x.jpg'
                                        imageEn='hierarchy/content-2-en@2x.jpg'/>
                                </Cell>
                            </Grid>

                            <div id="promo-badge-block">
                                <H4 space="TopDown">{intl.formatMessage({ id: 'design_3_4' })}</H4>
                                <Paragraph space="Down">{intl.formatMessage({ id: 'design_3_5' })}<Badge>{intl.formatMessage({ id: 'design_3_6' })}</Badge><br/>{intl.formatMessage({ id: 'design_3_7' })}</Paragraph>
                                <RuleDescription rule="do" />
                                <HierarchyItem2Img>
                                    <ImageMultilang 
                                        intl={intl} 
                                        // last="xs"
                                        imageRu='hierarchy/promo-do-1-ru@2x.jpg'
                                        imageUk='hierarchy/promo-do-1-uk@2x.jpg'
                                        imageEn='hierarchy/promo-do-1-en@2x.jpg'/>
                                </HierarchyItem2Img>
                                <RuleDescription rule="do" />
                                <HierarchyItem2Img>
                                    <ImageMultilang
                                        intl={intl} 
                                        // last="xs"
                                        imageRu='hierarchy/promo-do-2-ru@2x.jpg'
                                        imageUk='hierarchy/promo-do-2-uk@2x.jpg'
                                        imageEn='hierarchy/promo-do-2-en@2x.jpg' />
                                </HierarchyItem2Img>

                                <RuleDescription><FormattedHTMLMessage id="design_3_8" /></RuleDescription>
                                <HierarchyItem2Img>
                                    <ImageMultilang
                                        intl={intl} 
                                        // last="xs"
                                        imageRu='hierarchy/promo-dont-1-ru@2x.jpg'
                                        imageUk='hierarchy/promo-dont-1-uk@2x.jpg'
                                        imageEn='hierarchy/promo-dont-1-en@2x.jpg' />
                                </HierarchyItem2Img>
                                <HierarchyItem2Img>
                                    <ImageMultilang
                                        intl={intl} 
                                        // last="xs"
                                        imageRu='hierarchy/promo-dont-2-ru@2x.jpg'
                                        imageUk='hierarchy/promo-dont-2-uk@2x.jpg'
                                        imageEn='hierarchy/promo-dont-2-en@2x.jpg' />
                                </HierarchyItem2Img>

                                <H4 space="TopDown">{intl.formatMessage({ id: 'design_3_9' })}</H4>
                                <RuleDescription>{intl.formatMessage({ id: 'design_3_10' })}</RuleDescription>
                                <HierarchyItem2Img>
                                    <ImageMultilang
                                        intl={intl} 
                                        last="xs"
                                        imageRu='hierarchy/promo-dont-3-ru@2x.jpg'
                                        imageUk='hierarchy/promo-dont-3-uk@2x.jpg'
                                        imageEn='hierarchy/promo-dont-3-en@2x.jpg' />
                                </HierarchyItem2Img>

                                <H4 space="TopDown">{intl.formatMessage({ id: 'design_3_11' })}</H4>
                                <RuleDescription>{intl.formatMessage({ id: 'design_3_12' })}</RuleDescription>
                                <HierarchyItem2Img>
                                    <ImageMultilang
                                        intl={intl} 
                                        last="xs"
                                        imageRu='hierarchy/contrast-keyvisual-ru@2x.jpg'
                                        imageUk='hierarchy/contrast-keyvisual-uk@2x.jpg'
                                        imageEn='hierarchy/contrast-keyvisual-en@2x.jpg' />
                                </HierarchyItem2Img>
                            </div>
                        </AnchorBlock>
                    </Cell>
                </Grid>
            </Container>
            <ChapterSpace />
        </ParentAnchor>
        
    )
}

export default injectIntl(Design)


